export default [
  {
    text: "省发展改革委转发《国家发展改革委关于第三监管周期省级电网输配电价及有关事项的通知》的通知（苏发改价格发〔2023〕552号）.pdf）",
    url: "/pdf/zhengceFg/省发展改革委转发《国家发展改革委关于第三监管周期省级电网输配电价及有关事项的通知》的通知（苏发改价格发〔2023〕552号）.pdf",
  },
  {
    text: "省发展改革委关于进一步做好深化燃煤发电上网电价市场化改革工作的通知（苏发改价格发【2021】1008）（政策文件）",
    url: "/pdf/zhengceFg/省发展改革委关于进一步做好深化燃煤发电上网电价市场化改革工作的通知（苏发改价格发【2021】1008）.pdf",
  },

  {
    text: "省发展改革委关于进一步完善分时电价政策的通知（苏发改价格发〔2023〕555号）（政策文件）",
    url: "/pdf/zhengceFg/省发展改革委关于进一步完善分时电价政策的通知（苏发改价格发〔2023〕555号）.pdf",
  },

  {
    text: "电力监管条例  中华人民共和国国务院令  第432号（法律法规）",
    url: "/pdf/zhengceFg/电力监管条例  中华人民共和国国务院令  第432号.pdf",
  },
  {
    text: "电力设施保护条例  中华人民共和国国务院令（第239号）（法律法规）",
    url: "/pdf/zhengceFg/电力设施保护条例  中华人民共和国国务院令（第239号）.pdf",
  },
  {
    text: "电力供应与使用条例(2019年3月2日修正版)（法律法规）",
    url: "/pdf/zhengceFg/电力供应与使用条例(2019年3月2日修正版).pdf",
  },
  {
    text: "中华人民共和国电力法（2018年修正）（法律法规）",
    url: "/pdf/zhengceFg/中华人民共和国电力法（2018年修正）.pdf",
  },
  {
    text: "供电营业规则  中华人民共和国电力工业部令  第8号（法律法规）",
    url: "/pdf/zhengceFg/供电营业规则  中华人民共和国电力工业部令  第8号.pdf",
  },
  {
    text: "优化营商环境条例  中华人民共和国国务院令  第722号（法律法规）",
    url: "/pdf/zhengceFg/优化营商环境条例  中华人民共和国国务院令  第722号.pdf",
  },
 
  
  {
    text: "关于开展代理购电服务有关事项的公告（政策文件）",
    url: "/pdf/zhengceFg/关于开展代理购电服务有关事项的公告.pdf",
  },
  
  {
    text: "国家发展改革委关于2020年光伏发电上网电价政策有关事项的通知（政策文件）",
    url: "/pdf/zhengceFg/国家发展改革委关于2020年光伏发电上网电价政策有关事项的通知.pdf",
  },
  {
    text: "省发展改革委、省农业农村厅、省粮食和物资储备局关于明确农产品初加工用电价格有关事项的通知（苏发改价格发〔2021〕144号）（政策文件）",
    url: "/pdf/zhengceFg/省发展改革委、省农业农村厅、省粮食和物资储备局关于明确农产品初加工用电价格有关事项的通知（苏发改价格发〔2021〕144号）.pdf",
  },
  {
    text: "中华人民共和国国家发展和改革委员会令 第36号 承装（修、试）电力设施许可证管理办法（政策文件）",
    url: "/pdf/zhengceFg/中华人民共和国国家发展和改革委员会令 第36号 承装（修、试）电力设施许可证管理办法.pdf",
  },
  {
    text: "苏监能稽查〔2020〕115号　江苏能源监管办印发《江苏能源监管办全面提升获得电力服务水平 持续优化用电营商环境三年行动方案》（2020-2022年）》的通知（政策文件）",
    url: "/pdf/zhengceFg/苏监能稽查〔2020〕115号　江苏能源监管办印发《江苏能源监管办全面提升获得电力服务水平 持续优化用电营商环境三年行动方案》（2020-2022年）》的通知.pdf",
  },
  {
    text: "省发展改革委关于完善居民阶梯电价有关问题的通知（苏发改价格发(2021)106号）（政策文件）",
    url: "/pdf/zhengceFg/省发展改革委关于完善居民阶梯电价有关问题的通知（苏发改价格发(2021)106号）.pdf",
  },
  {
    text: "省发展改革委关于明确有关涉农行业用电价格政策的通知（茶叶、大米、饲料加工、农村保鲜仓储）（苏发改价格发[2020]360号）（政策文件）",
    url: "/pdf/zhengceFg/省发展改革委关于明确有关涉农行业用电价格政策的通知（茶叶、大米、饲料加工、农村保鲜仓储）（苏发改价格发[2020]360号）.pdf",
  },
  {
    text: "江苏省电力条例（新颁布）（政策文件）",
    url: "/pdf/zhengceFg/江苏省电力条例（新颁布）.pdf",
  },
  {
    text: "国能监管〔2013〕408号 国家能源局关于进一步规范用户受电工程市场的通知（政策文件）",
    url: "/pdf/zhengceFg/国能监管〔2013〕408号 国家能源局关于进一步规范用户受电工程市场的通知.pdf",
  },
  {
    text: "《国家能源局关于印发《供电企业信息公开实施办法》的通知》-国能监管〔2014〕149号（政策文件）",
    url: "/pdf/zhengceFg/《国家能源局关于印发《供电企业信息公开实施办法》的通知》-国能监管〔2014〕149号.pdf",
  },
  {
    text: "发改价格〔2019〕761号　国家发展改革委关于完善光伏发电上网电价机制有关问题的通知（政策文件）",
    url: "/pdf/zhengceFg/发改价格〔2019〕761号　国家发展改革委关于完善光伏发电上网电价机制有关问题的通知.pdf",
  },
  {
    text: "国家电力监管委员会令 第 9 号   电力业务许可证管理规定（政策文件）",
    url: "/pdf/zhengceFg/国家电力监管委员会令 第 9 号   电力业务许可证管理规定.pdf",
  },
  {
    text: "关于颁发《功率因数调整电费办法》的通知（〔83〕水电财字第215号）（政策文件）",
    url: "/pdf/zhengceFg/关于颁发《功率因数调整电费办法》的通知（〔83〕水电财字第215号）.pdf",
  },
];
